// extracted by mini-css-extract-plugin
export default {"Truncate":"Truncate1OzxBYrNNfH3","Truncate_line-clamp":"Truncate_line-clamp35wX8SUwvX6e"};